export function getContrastRatio(hex1: string, hex2: string): number {
  function hexToRgb(hex: string) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return [r, g, b].map((v) => v / 255);
  }
  function luminance([r, g, b]: number[]) {
    const a = [r, g, b].map((v) =>
      v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4,
    );
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }
  const lum1 = luminance(hexToRgb(hex1));
  const lum2 = luminance(hexToRgb(hex2));
  return (Math.max(lum1, lum2) + 0.05) / (Math.min(lum1, lum2) + 0.05);
}

export function darken(hex: string, amount: number): string {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  r = Math.max(0, Math.floor(r * (1 - amount)));
  g = Math.max(0, Math.floor(g * (1 - amount)));
  b = Math.max(0, Math.floor(b * (1 - amount)));
  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

export function lighten(hex: string, amount: number): string {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  r = Math.min(255, Math.floor(r + (255 - r) * amount));
  g = Math.min(255, Math.floor(g + (255 - g) * amount));
  b = Math.min(255, Math.floor(b + (255 - b) * amount));
  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

export function getAccessibleFocusColor(
  brandColor: string,
  minRatio = 3,
): string {
  let color = brandColor;
  let amount = 0.1;
  // Try darkening first
  for (let i = 0; i < 10; i += 1) {
    if (getContrastRatio(color, brandColor) >= minRatio) {
      return color;
    }
    color = darken(brandColor, amount);
    amount += 0.1;
  }
  // Try lightening
  color = brandColor;
  amount = 0.1;
  for (let i = 0; i < 10; i += 1) {
    if (getContrastRatio(color, brandColor) >= minRatio) {
      return color;
    }
    color = lighten(brandColor, amount);
    amount += 0.1;
  }
  // Fallback: use white or black, whichever has better contrast
  return getContrastRatio('#fff', brandColor) >
    getContrastRatio('#000', brandColor)
    ? '#fff'
    : '#000';
}
